import { FaUser } from 'react-icons/fa';
import ActionButton from 'components/ActionButton';
import useProfileConfig from 'hooks/useProfileConfig';

const ProfileConfigButton = ({ icon = false }: { icon?: boolean }) => {
  const { data } = useProfileConfig();

  if (!data) return null;

  // The server sends this button without an icon, so the header's icon form draws its own.
  return icon ? (
    <ActionButton {...data} size="medium" asIcon startIcon={<FaUser />} />
  ) : (
    <ActionButton {...data} size="medium" />
  );
};

export default ProfileConfigButton;
